export default {
  sm: '0px',
  md: '2px',
  lg: '5px',
  xl: '11px',
  round: '100%',
};
